import LegalPage from "./LegalPage";
import { termsBlocks } from "./termsContent";

export default function TermsPage() {
  return <LegalPage title="Terms and Conditions" blocks={termsBlocks} />;
}
